module.exports = __webpack_public_path__ + "static/media/topImage.bd8172da.png";